var hashtag_default = {
  "fontElementMap": "cifOp",
  "hashtag": "Dmz8v"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
